import { MuiThemeProvider } from '@material-ui/core/styles';
import React, { Component } from "react";
import {
  getSession,
} from "./general_functions/general";
import Login from "../login";
import PostMain from "./cpanel/post/PostMain";

class AdminPanel extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    getSession(res => {
      if (res.isLoggedIn) {
        this.props.context.login(res);
      }
    });
  }

  render() {
    let { context } = this.props;
    return (
      <div>
        {context.authenticated == false ? (
          <Login context={context} />
        ) : (
          <PostMain context={context}/>
        )}
      </div>
    );
  }
}

export default AdminPanel;
